const addressHelpers = require('./address');
const formHelpers = require('./formErrors');
const cleave = require('../components/cleave');
const scrollAnimate = require('../components/scrollAnimate');
const clientSideValidation = require('../components/clientSideValidation');

function padLeft(data, size, paddingChar) {
    return (new Array(size + 1).join(paddingChar || '0') + String(data)).slice(-size);
}

/**
 * updates the billing address selector within billing forms
 * @param {object} order - the order model
 * @param {object} customer - the customer model
 */
function updateBillingAddressSelector(order, customer) {
    const form = $('form[name$=billing]')[0];
    const $billingAddressSelector = $('.addressSelector', form);
    let hasSelectedAddress = false;

    if ($billingAddressSelector && $billingAddressSelector.length === 1) {
        $billingAddressSelector.empty();
        // Add New Address option
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order,
            { type: 'billing' }
        ));

        if (customer && customer.addresses && customer.addresses.length > 0) {
            $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses, false, order
            ));
            customer.addresses.forEach((address) => {
                const isSelected = order.billing.matchingAddressId === address.ID;
                hasSelectedAddress = hasSelectedAddress || isSelected;
                // Customer Address option
                $billingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress({
                        UUID: `ab_${address.ID}`,
                        shippingAddress: address
                    }, isSelected, order, { type: 'billing' })
                );
            });
        }
    }

    if (hasSelectedAddress ||
        (!order.billing.matchingAddressId && order.billing.billingAddress.address)) {
        // show
        $(form).attr('data-address-mode', 'edit');
    } else {
        $(form).attr('data-address-mode', 'new');
    }

    $billingAddressSelector.show();
}

/**
 * updates the billing address form values within payment forms
 * @param {object} order - the order model
 * @returns {undefined}
 */
function updateBillingAddressFormValues(order) {
    const { billing } = order;
    if (!billing.billingAddress || !billing.billingAddress.address) {
        return;
    }

    const form = $('form[name=dwfrm_billing]');
    if (!form) {
        return;
    }

    $('input[name$=_firstName]', form).val(billing.billingAddress.address.firstName);
    $('input[name$=_lastName]', form).val(billing.billingAddress.address.lastName);
    $('input[name$=_address1]', form).val(billing.billingAddress.address.address1);
    $('input[name$=_address2]', form).val(billing.billingAddress.address.address2);
    $('input[name$=_city]', form).val(billing.billingAddress.address.city);
    $('input[name$=_postalCode]', form).val(billing.billingAddress.address.postalCode);
    $('select[name$=_stateCode],input[name$=_stateCode]', form)
        .val(billing.billingAddress.address.stateCode);
    $('select[name$=_country]', form).val(billing.billingAddress.address.countryCode.value);
    $('input[name$=_phone]', form).val(billing.billingAddress.address.phone);
    $('input[name$=_email]', form).val(order.orderEmail);

    form.trigger('change');
}

/**
 * clears the billing address form values
 */
function clearBillingAddressFormValues() {
    updateBillingAddressFormValues({
        billing: {
            billingAddress: {
                address: {
                    countryCode: {
                        value: 'CA'
                    }
                }
            }
        }
    });
}

/**
 * Updates the billing information in checkout, based on the supplied order model
 * @param {object} order - checkout model to use as basis of new truth
 * @param {object} customer - customer model to use as basis of new truth
 */
function updateBillingInformation(order, customer) {
    updateBillingAddressSelector(order, customer);

    // update billing address form
    updateBillingAddressFormValues(order);

    // update billing address summary
    addressHelpers.methods.populateAddressSummary('.billing',
        order.billing.billingAddress.address);

    // update billing parts of order summary
    $('.order-summary-email').text(order.orderEmail);

    if (order.billing.billingAddress.address) {
        $('.order-summary-phone').text(order.billing.billingAddress.address.phone);
    }

    if (order.rClubNumber) {
        $('.order-summary-rClubNumber').text(order.rClubNumber);
    }
}

/**
 * Updates the payment information in checkout, based on the supplied order model
 * @param {object} order - checkout model to use as basis of new truth
 */
function updatePaymentInformation(order) {
    // update payment details
    const $paymentSummary = $('.payment-details');
    let htmlToAppend = '';

    if (order.billing.payment && order.billing.payment.selectedPaymentInstruments &&
        order.billing.payment.selectedPaymentInstruments.length > 0) {
        order.billing.payment.selectedPaymentInstruments.forEach((selectedPaymentInstrument, index) => {
            const marginClass = index > 0 ? 'payment-details-container' : '';

            if (selectedPaymentInstrument.giftCardNumber) {
                htmlToAppend += `
                    <div class="${marginClass}">
                        <span>
                            ${window.Resources.giftcards.order.number} ${selectedPaymentInstrument.giftCardNumber}
                        </span>
                        <br/>
                        <span>
                            ${window.Resources.giftcards.order.amount} ${selectedPaymentInstrument.amount.formatted}
                        </span>
                    </div>`;
            } else if (selectedPaymentInstrument.paymentMethod === 'PayPal') {
                htmlToAppend += `
                <span class="${marginClass}">
                    ${selectedPaymentInstrument.fundingSource ? selectedPaymentInstrument.fundingSource + ' / ' + order.priceTotal : selectedPaymentInstrument.paymentMethod + ' / ' + order.priceTotal}
                </span>`;
            } else {
                var cardType = order.resources.cardType; // Default to "Credit Card"
                if (selectedPaymentInstrument.type && selectedPaymentInstrument.type !== 'Card') {
                    cardType = selectedPaymentInstrument.type;
                }
                htmlToAppend += `
                <div class="${marginClass}">
                    ${cardType}: ${order.priceTotal}
                </div>
                `;
            }
        });
    }

    $paymentSummary.empty().append(htmlToAppend);
}

/**
 * Updates the "R" club card number information in checkout, based on the supplied order model
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updateRClubCardNumberInformation(order) {
    var $rClubCardContainer = $('.js-rclub_card-container');
    var htmlToAppend = '';

    if (order.rClubNumber) {
        htmlToAppend += `
            <div class="b-card-section m-with_divider">
                <h3 class="b-card-label">${window.Resources.fields.rClubCardNumber}:</h3>
                <div>${order.rClubNumber}</div>
            </div>
        `;
    }

    $rClubCardContainer.empty().append(htmlToAppend);
}

/**
 * clears the credit card form
 * @param {*} $formContainer
 */
function clearCreditCardForm($formContainer) {
    $formContainer.find('#cardOwner').val('');
    $formContainer.find('#cardNumber').val('').data('cleave').setRawValue('');
    $formContainer.find('#expirationMonth').val('');
    $formContainer.find('#expirationYear').val('').trigger('sync');
    $formContainer.find('#securityCode').val('');
}

/**
 * Updates the payment look in checkout
 * @param {object} order - checkout model to use as basis of new truth
 * @param {string} [congratsMessage] - Congratulations message
 */
function updateBillingLook(order, congratsMessage) {
    const $activeTab = $('.js-tab-pane.active');
    const $congratsBlock = $('.js-congrats-block');
    const $paymentMethod = $activeTab.find('.js-payment-method');
    const $gcElementsForHiding = $('.js-giftcard-hiding');
    const $otherElementsForHiding = $('.js-billing-hiding');
    const activeBillingPaymentMethod = $('.js-payment-option.m-checked').find('.js-payment-option-label').data('method-id');

    // update payment look
    if (typeof congratsMessage === 'string') {
        $('.js-congrats-text').text(congratsMessage);
    }
    $otherElementsForHiding.toggleClass('h-hidden', order.totals.zeroTotal);
    $congratsBlock.toggleClass('h-hidden', !order.totals.zeroTotal);
    $gcElementsForHiding.toggleClass('h-hidden', order.totals.zeroTotal || order.billing.payment.isGiftCardsMaximumCountReached);
    $paymentMethod.val(order.totals.zeroTotal
        ? ''
        : activeBillingPaymentMethod);

    if ($('#checkout-main').attr('data-checkout-stage') == "payment") {
        toggleReviewOrderButton(order.totals.zeroTotal);
    }
}

/**
 * Update giftcards container
 * @param {object} order - checkout model to use as basis of new truth
 */
function updateGiftCardContainer(order) {
    const selectedGiftCardsHtml = order && order.billing && order.billing.payment && order.billing.payment.selectedGiftCardsHtml || '';
    const $giftCardContainer = $('.js-billing-giftcards-container');
    $giftCardContainer.html(selectedGiftCardsHtml);
    const $giftCardInputs = $('.js-giftcardNumber-input, .js-pinNumber-input');
    $giftCardInputs.val('').trigger('change');
    $giftCardInputs.removeClass('is-invalid');
    $giftCardInputs.next('.invalid-feedback').empty();
}

/**
 * Get BillingAddress serialized form
 * @returns {String}
 */
function getBillingAddressForm() {
    const billingAddressForm = $('[data-js-payment-form] .billing-address-block');
    const billingAddressSerialize = billingAddressForm.serialize();
    let billingAddressData = '';
    $('body').trigger('checkout:serializeBilling', {
        form: billingAddressForm,
        data: billingAddressSerialize,
        callback(data) {
            if (data) {
                billingAddressData = data;
            }
        }
    });
    return billingAddressData;
}

/**
 * Get ContactInfo serialized form
 * @returns {String}
 */
function getContactInfoForm() {
    const contactInfoForm = $('[data-js-payment-form] .contact-info-block');
    const contactInfoSerialize = contactInfoForm.serialize();
    const $activeTab = $('.js-tab-pane.active');
    const $paymentMethod = $activeTab.find('.js-payment-method');
    const paymentMethodName = $paymentMethod.attr('name');
    const paymentMethodVal = $paymentMethod.val();
    let contactInfoData = '';

    $('body').trigger('checkout:serializeBilling', {
        form: contactInfoForm,
        data: contactInfoSerialize,
        callback(data) {
            if (data) {
                contactInfoData = data;
            }
        }
    });
    return contactInfoData.replace(`${paymentMethodName}=${paymentMethodVal}`, '');
}

/**
 * Get RClubNumber serialized form
 * @returns {String}
 */
function getRClubNumberForm() {
    let rClubNumberForm = $('.js-rclubnumber-info-block');
    const rClubNumberSerialize = rClubNumberForm.serialize();
    let rClubNumberData = '';

    $('body').trigger('checkout:serializeBilling', {
        form: rClubNumberForm,
        data: rClubNumberSerialize,
        callback(data) {
            if (data) {
                rClubNumberData = data;
            }
        }
    });
    return rClubNumberData;
}

/**
 * Get GiftCard serialized form
 * @returns {String}
 */
function getGiftCardForm() {
    const giftcardNumber = $('.js-giftcardNumber-input').val();
    const giftcardNumberName = $('.js-giftcardNumber-input').attr('name');
    const pinNumber = $('.js-pinNumber-input').val();
    const pinNumberName = $('.js-pinNumber-input').attr('name');
    const giftcardsPaymentMethod = $('#js-giftcards-payment-method').val();
    const paymentMethodName = $('.js-payment-method').first().attr('name');

    return `${giftcardNumberName}=${giftcardNumber}&${pinNumberName}=${pinNumber}&${paymentMethodName}=${giftcardsPaymentMethod}`;
}

/**
 * Glue up all forms
 * @param {String} billingAddressForm - billingAddress serialized form
 * @param {String} contactInfoForm - contactInfo serialized form
 * @param {String} rClubNumberForm - rClubNumber serialized form
 * @param {String} giftCardForm - giftCard serialized form
 * @returns {String}
 */
function getPaymentForm(billingAddressForm, contactInfoForm, rClubNumberForm, giftCardForm) {
    return `${billingAddressForm}&${contactInfoForm}&${rClubNumberForm}&${giftCardForm}`;
}

function selectSavedPayment($savedPayment) {
    //Clear all selections
    $('.saved-payment-instrument').removeClass('selected-payment');
    $savedPayment.addClass('selected-payment');
    $savedPayment.find('.saved-payment-security-code').val('');
}

function collapseNewPayment($currentPayment) {
    $currentPayment.removeClass('selected-payment');
    $('.js-payment-information').data('is-new-payment', false);
    $("button.submit-payment").show();
}

function expandNewPayment($currentPayment) {
    $('.saved-payment-instrument').removeClass('selected-payment');
    $currentPayment.addClass('selected-payment');
    $('.saved-payment-security-code').val('');
    $('.js-payment-information').data('is-new-payment', true);
    $("button.submit-payment").hide();
}

function toggleReviewOrderButton(isCardFormHidden) {
    var paymentOptionSelected = $(".credit-card-selection-new").find(".m-checked");
    var methodID = $(paymentOptionSelected).find(".js-payment-option-label").data("method-id");
    var $congratsBlock = $(".js-congrats-block");

    var $usedPaymentMethod = $('.js-used-payment-method');
    if ($usedPaymentMethod.length && !methodID) {
        methodID = $usedPaymentMethod.val();
    }

    $('body').trigger('checkout:totalsChanged');

    if ($congratsBlock.length > 0 && !$congratsBlock.hasClass("h-hidden")) {
        $("button.submit-payment").show();
        return;
    }

    if (methodID && methodID == "PayPal") {
        $("button.submit-payment").hide();
        return;
    }

    if (methodID && methodID == "PAYPAL_CREDIT_CARD") {
        $("button.submit-payment").hide();
        return;
    }

    if (!isCardFormHidden && methodID && methodID == "CREDIT_CARD") {
        var selectedPayment = $(".payment-form-fields").find(".selected-payment");
        var isSavedPaymentInstrument = $(selectedPayment).hasClass("saved-payment-instrument");

        if (isSavedPaymentInstrument) {
            $("button.submit-payment").show();
        } else {
            $("button.submit-payment").hide();
        }
    } else {
        $("button.submit-payment").show();
    }
}

function billingAddressSameAsShippingFunction() {
    if ($(".js-same-as-shipping:visible").is(":checked")) {
        var formBilling = $("form[name=dwfrm_billing]");
        var formShipping = $("form[name=dwfrm_shipping]");
        var guestEmail = $(".js-checkout-as-guest-email");

        $(".address-selector-section").addClass("d-none");
        $(".js-billing-address").addClass("d-none");
        $("input[name$=_firstName]", formBilling).val($("input[name$=_firstName]", formShipping).val());
        $("input[name$=_lastName]", formBilling).val($("input[name$=_lastName]", formShipping).val());
        $("input[name$=_address1]", formBilling).val($("input[name$=_address1]", formShipping).val());
        $("input[name$=_address2]", formBilling).val($("input[name$=_address2]", formShipping).val());
        $("select[name$=_country]", formBilling).val('CA');
        $("select[name$=_stateCode]", formBilling).val($("select[name$=_stateCode]", formShipping).val());
        $("input[name$=_city]", formBilling).val($("input[name$=_city]", formShipping).val());
        $("input[name$=_postalCode]", formBilling).val($("input[name$=_postalCode]", formShipping).val());
        $("input[name$=_phone]", formBilling).val($("input[name$=_phone]", formShipping).val());
        $("input#email", formBilling).val(guestEmail.val());
    } else {
        var formBilling = $("form[name=dwfrm_billing]");
        var email = $('input[name$=_email]', formBilling).val();
        var phone = $('input[name$=_phone]', formBilling).val();
        clearBillingAddressFormValues();
        $('input[name$=_email]', formBilling).val(email);
        $('input[name$=_phone]', formBilling).val(phone);

        $(".address-selector-section").removeClass("d-none");
        $(".js-billing-address").removeClass("d-none");
    }
}

function togglePaymentMethods () {
    const billingForm = $('#dwfrm_billing');
    let areRequiredFieldsFilled = true;
    billingForm.find('input, select').each(function () {
        if ($(this).is(':visible') && $(this).parent().hasClass('required')) {
            if ($(this).val().trim() === '') {
                areRequiredFieldsFilled = false;
            }
        }
    });

    if (areRequiredFieldsFilled && clientSideValidation.functions.validateForm(billingForm)) {
        $('.js-payment-methods-list').removeClass('d-none');
        $('.js-payment-methods-text').addClass('d-none');
    } else {
        $('.js-payment-methods-list').addClass('d-none');
        $('.js-payment-methods-text').removeClass('d-none');
    }
}

function validateEmptyInput(element) {
    const elementValue = element.val().trim(); // Get and trim the value

    if (elementValue === '') {
        // Trigger custom invalid feedback
        element.addClass('is-invalid'); // Add error class (e.g., for Bootstrap styles)
        element.next('.invalid-feedback').text('This field is required..').show(); // Display error message
        return false;
    }

    element.removeClass('is-invalid');
    element.next('.invalid-feedback').text('');
    return true;
}

module.exports = {
    methods: {
        updateBillingAddressSelector,
        updateBillingAddressFormValues,
        clearBillingAddressFormValues,
        updateBillingInformation,
        updatePaymentInformation,
        updateRClubCardNumberInformation,
        updateBillingLook,
        clearCreditCardForm,
        updateGiftCardContainer,
        toggleReviewOrderButton,
        billingAddressSameAsShippingFunction,
        togglePaymentMethods
    },

    showBillingDetails() {
        $('.btn-show-billing-details').on('click', function () {
            $(this).parents('[data-address-mode]').attr('data-address-mode', 'new');
        });
    },

    hideBillingDetails() {
        $('.btn-hide-billing-details').on('click', function () {
            $(this).parents('[data-address-mode]').attr('data-address-mode', 'shipment');
        });
    },

    selectBillingAddress() {
        $('.payment-form .addressSelector').on('change', function () {
            const $form = $(this).closest('form');
            const $selectedOption = /** @type {JQuery<HTMLOptionElement>} */($('option:selected', this));
            const optionID = $selectedOption.val();

            if (optionID === 'new') {
                // Show Address
                $($form).attr('data-address-mode', 'new');
            } else {
                // Hide Address
                $($form).attr('data-address-mode', 'shipment');
            }

            // Copy fields
            const fieldNames = $selectedOption.data();

            Object.keys(fieldNames).forEach(attr => {
                const fieldName = attr === 'countryCode' ? 'country' : attr;
                if (fieldName === 'cardNumber') {
                    $('.cardNumber').data('cleave').setRawValue(fieldNames[attr]);
                } else {
                    $(`[name$=${fieldName}]`, $form).val(fieldNames[attr]);
                }
            });
        });
    },

    applyGiftCard() {
        $(document).on('click', '.js-billing-giftcards-apply', (e) => {
            e.preventDefault();

            if (validateEmptyInput($('#giftcardNumber')) && validateEmptyInput($('#pinNumber'))) {
                const giftCardBlock = $('.js-gift-cards-block');

                const $paymentMethodInputs = $('.js-payment-method');
                $paymentMethodInputs.prop('disabled', true);

                let billingAddressForm = getBillingAddressForm();
                let contactInfoForm = getContactInfoForm();
                let rClubNumberForm = getRClubNumberForm();
                let giftCardForm = getGiftCardForm();
                let paymentForm = getPaymentForm(billingAddressForm, contactInfoForm, rClubNumberForm, giftCardForm);

                $paymentMethodInputs.prop('disabled', false);

                giftCardBlock.spinner().start();
                // disable the next:Place Order button here
                $('body').trigger('checkout:disableButton', '.js-next-step-button button');
                $.ajax({
                    url: $('[data-js-payment-form]').attr('action'),
                    method: 'POST',
                    data: paymentForm,
                    success(data) {
                        giftCardBlock.spinner().stop();
                        // enable the next:Place Order button here
                        $('body').trigger('checkout:enableButton', '.js-next-step-button button');
                        // look for field validation errors
                        if (data.error) {
                            if (data.fieldErrors.length) {
                                data.fieldErrors.forEach((error) => {
                                    if (Object.keys(error).length) {
                                        formHelpers.loadFormErrors('.payment-form', error);
                                    }
                                });
                            }

                            if (data.serverErrors.length) {
                                let errorMessage = '';
                                data.serverErrors.forEach((error) => {
                                    errorMessage += error;
                                });
                                $('.error-message-text').text(errorMessage);
                                $('.error-message').show();
                                scrollAnimate($('.error-message'));
                            }
                        } else {
                            const {order, customer, congratsMessage} = data;

                            window.dialogManager.openDialog('modal', '#applyGiftCardModal', document.body);
                            updateGiftCardContainer(order);
                            updateBillingLook(order, congratsMessage);
                            $('body').trigger('checkout:updateCheckoutView', {order, customer});
                            $('.error-message').hide();
                            toggleReviewOrderButton(order.totals.zeroTotal);
                        }
                    },
                    error(err) {
                        giftCardBlock.spinner().stop();
                        if (err.responseJSON && err.responseJSON.redirectUrl) {
                            window.window.location.href = err.responseJSON.redirectUrl;
                        }

                        if (err.responseJSON && err.responseJSON.message) {
                            $('.error-message-text').text(err.responseJSON.message);
                            $('.error-message').show();
                            scrollAnimate($('.error-message'));
                        }
                    }
                });
            }
        });
    },

    removeGiftCard() {
        $(document).on('click', '.js-billing-giftcards-remove', function (e) {
            e.preventDefault();
            const giftCardBlock = $('.js-gift-cards-block');
            const appliedContainer = $(this).closest('.js-billing-giftcards-applied');
            const csrfToken = $('.js-csrf-token');
            const csrfTokenName = csrfToken.attr('name');
            const csrfTokenVal = csrfToken.val();
            const certID = appliedContainer.data('cert-id');

            giftCardBlock.spinner().start();
            // disable the next:Place Order button here
            $('body').trigger('checkout:disableButton', '.js-next-step-button button');
            $.ajax({
                url: $('.js-gift-cards-block').attr('action-url-remove'),
                method: 'POST',
                data: `giftcardid=${certID}&${csrfTokenName}=${csrfTokenVal}`,
                success(data) {
                    giftCardBlock.spinner().stop();
                    // enable the next:Place Order button here
                    $('body').trigger('checkout:enableButton', '.js-next-step-button button');
                    if (data.error) {
                        if (data.fieldErrors.length) {
                            data.fieldErrors.forEach((error) => {
                                if (Object.keys(error).length) {
                                    formHelpers.loadFormErrors('.payment-form', error);
                                }
                            });
                        }

                        if (data.serverErrors.length) {
                            let errorMessage = '';
                            data.serverErrors.forEach((error) => {
                                errorMessage += error;
                            });
                            $('.error-message-text').text(errorMessage);
                            $('.error-message').show();
                            scrollAnimate($('.error-message'));
                        }
                    } else {
                        const { order } = data;
                        updateGiftCardContainer(order);
                        updateBillingLook(order);
                        $('body').trigger('checkout:updateCheckoutView', { order });
                        var hasRecaptcha = $('#js-g-recaptcha-hpp').length > 0;

                        if (hasRecaptcha) {
                            $("body").trigger("checkout:resetRecaptcha");
                        }

                        $('.error-message').hide();
                        toggleReviewOrderButton(order.totals.zeroTotal);
                    }
                },
                error(err) {
                    giftCardBlock.spinner().stop();
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }

                    if (err.responseJSON && err.responseJSON.message) {
                        $('.error-message-text').text(err.responseJSON.message);
                        $('.error-message').show();
                        scrollAnimate($('.error-message'));
                    }
                }
            });
        });
    },

    handleRequiredPropGiftCardInputs() {
        var giftCardInputs = $('.js-giftcardNumber-input, .js-pinNumber-input');
        giftCardInputs.prop('required', false).on('change', () => {
            const isSomeFieldFilled = giftCardInputs.toArray()
                .some(field => $(field).val());

            giftCardInputs.prop('required', isSomeFieldFilled);

            if (!isSomeFieldFilled) {
                $('.js-gift-cards-block').find('.invalid-feedback').empty();
                giftCardInputs.removeClass('is-invalid');
            }
        });
    },

    handleCreditCardNumber() {
        if ($('.cardNumber').length && $('#cardType').length) {
            cleave.handleCreditCardNumber('.cardNumber', '#cardType');
        }
    },

    sanitizeForm() {
        $('body').on('checkout:serializeBilling', (e, data) => {
            const serializedForm = cleave.serializeData(data.form);

            data.callback(serializedForm);
        });
    },

    selectSavedPaymentInstrument() {
        $(document).on('click', '.saved-payment-instrument', (e) => {
            // Select saved payment
            e.preventDefault();
            if (!$(e.currentTarget).hasClass('selected-payment')) {
                var $newPayment = $('.js-new-payment');
                collapseNewPayment($newPayment);
                selectSavedPayment($(e.currentTarget));
            }
        });
    },

    clickNewPayment() {
        $(document).on('click', '.js-add-payment', (e) => {
            // Expand Add New Payment on click
            e.preventDefault();
            var $currentPayment = $(e.currentTarget.parentElement);
            if (!$currentPayment.hasClass('selected-payment')) {
                // Expand Add Payment
                expandNewPayment($currentPayment);
            }
        });
        $(document).on('dblclick', '.js-add-payment', (e) => {
            // Collapse Add New Payment on double click
            e.preventDefault();
            var $currentPayment = $(e.currentTarget.parentElement);
            if ($currentPayment.hasClass('selected-payment')) {
                // Collapse Add Payment
                collapseNewPayment($currentPayment);
                var $savedPayment = $('.saved-payment-instrument').first();
                selectSavedPayment($savedPayment);
            }
        });
    },

    clearBillingForm() {
        $('body').on('checkout:clearBillingForm', () => {
            clearBillingAddressFormValues();
        });
    },

    paymentOptions() {
        $('.js-payment-option-label').on('click', function (e) {
            e.preventDefault();
            const methodID = $(this).data('method-id');
            $('.js-payment-information').data('payment-method-id', methodID);

            const selectedOption = $(this).parents('.js-payment-option');
            $('.js-payment-option').removeClass('m-checked');
            $('.js-tab-pane').removeClass('active');
            selectedOption.addClass('m-checked');
            selectedOption.find('.js-tab-pane').addClass('active');
            scrollAnimate(selectedOption);
            toggleReviewOrderButton();

            $('body').trigger('payment:clearHostedFields');
        });
    },
    actualizeMonth() {
        $('.js-expiration-year').on('change sync', function () {
            const $expirationYear = $(this);
            const $expirationMonth = $('.js-expiration-month');
            const FULL_OPTIONS_AMOUNT = 13;

            const currentDate = new Date();
            const currentMount = currentDate.getMonth() + 1;
            const currentVal = $expirationMonth.val();

            if ($expirationYear.val() === String(currentDate.getFullYear())) {
                if ($expirationMonth.find('option').length === FULL_OPTIONS_AMOUNT) {
                    // remove all
                    $expirationMonth.find('option').filter((_, option) => $(option).val()).remove();

                    // add only required
                    Array.from(Array(12 - currentMount + 1)).forEach((_, idx) => {
                        const val = currentMount + idx;
                        const month = padLeft(val, 2, '0');

                        $expirationMonth.append(`<option value="${val}">${month}</option>`);
                    });
                    $expirationMonth.find(`option[value=${currentVal}]`).each(() => {
                        $expirationMonth.val(currentVal);
                    });
                }
            } else if ($expirationMonth.find('option').length !== FULL_OPTIONS_AMOUNT) {
                // restore options only if was changed before
                // clean options
                $expirationMonth.find('option').filter((_, option) => $(option).val()).remove();

                // add all
                Array.from(Array(12)).forEach((_, idx) => {
                    const month = padLeft(1 + idx, 2, '0');

                    $expirationMonth.append(`<option value="${idx + 1}">${month}</option>`);
                });
                $expirationMonth.val(currentVal);
            }
        });
    },
    billingAddressSameAsShipping: function () {
        $(".js-same-as-shipping").on("change", billingAddressSameAsShippingFunction);
    },
    validateProvince: function() {
        $("#billingState").on("change", function () {
            var $this = $(this);
            var validateUrl = $this.data('validateUrl');

            var stateCode = $this.val();

            var $provinceErrorBlock = $this.siblings('.invalid-feedback');
            var $billinggProvinceCaption = $('#billing-province-caption');

            if (validateUrl) {
                // @ts-ignore
                $.ajax({
                    url: validateUrl,
                    type: 'post',
                    data: {stateCode: stateCode},
                    dataType: 'json',
                    success(data) {
                        if (data.provinceError) {
                            $billinggProvinceCaption.hide();

                            $provinceErrorBlock.text(data.errorMsg);
                            $provinceErrorBlock.show();
                        } else {
                            if ($provinceErrorBlock) {
                                $provinceErrorBlock.hide();
                            }

                            if ($billinggProvinceCaption) {
                                $billinggProvinceCaption.show();
                            }
                        }
                    }
                });
            }
        });
    },
    handleReturnToPaymentStage: function() {
        $('body').on('checkout:returnedToPaymentStage', function() {
            $('body').trigger('payment:clearHostedFields');
        });
    }
};
